import React, { forwardRef } from 'react';
import ConversationWriteExercise from './ConversationWriteExercise';

// Poslechové cvičení = totéž jako Dialogy, jen s jiným exercise_type (vlastní
// pokrok a XP) a skrytým textem dialogu do dokončení otázek. Veškerá logika
// (načtení dialogu, audio, otázky, hodnocení, záznam pokusu) se znovupoužívá.
const ConversationListeningExercise = forwardRef((props, ref) => (
  <ConversationWriteExercise
    {...props}
    ref={ref}
    exerciseType="conversation_listening"
    listenMode
  />
));

export default ConversationListeningExercise;
